import React, { Fragment, useState } from "react";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { useMutation } from "@apollo/client";
import { SEND_CONTACT } from "../../../queries";
import { useLoginStatus } from "../../../Layout/AppMain/LoginStatusContext";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";

const FormContents = () => {
  const loginStatus = useLoginStatus();

  //問合わせ内容送信
  const [sendContact, { data, loading, error }] = useMutation(SEND_CONTACT);
  const thanksMessage = withReactContent(Swal);

  const [contents, setContents] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    comment: "",
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    window.location.href = "/#/dashboards/journy";
  }

  const onSubmit = async () => {
    try {
      if (
        contents.name === "" ||
        contents.email === "" ||
        contents.comment === ""
      ) {
        alert("未入力の項目があります");
      } else {
        await sendContact({
          variables: {
            userId: loginStatus,
            name: contents.name,
            email: contents.email,
            phoneNumber: contents.phoneNumber,
            comment: contents.comment,
          },
        });
        await thanksMessage
          .fire({
            title: (
              <p style={{ fontSize: 16 }}>
                お問い合わせいただきありがとうございました。
                <br />
                担当者より折り返しご連絡いたします。
              </p>
            ),
            icon: "success",
            confirmButtonText: "マップに戻る",
          })
          .then(function () {
            window.location.href = "/#/dashboards/journy";
            // <Link to="/#/dashboards/journy" />;
          });
      }
    } catch (err) {
      alert("データが送信されませんでした。再度ご入力ください");
    }
  };

  return (
    <Fragment>
      <AvForm>
        <AvGroup>
          <div className="formContent">
            <div className="form-wizard-content">
              <div className="box ema__flex ema__align_items_center">
                <Label for="exampleEmail55" className="contactTitle">
                  氏名
                  {/* <span>※必須</span> */}
                </Label>
                <AvInput
                  type="text"
                  name="name"
                  id="exampleEmail55"
                  placeholder="氏名を入力してください"
                  className="form-control mb-2"
                  forcePoly={true}
                  autoComplete={false}
                  required
                  onChange={(e) => {
                    setContents({ ...contents, name: e.target.value });
                  }}
                />
              </div>
              <div className="box ema__flex ema__align_items_center">
                <Label for="examplePassword22" className="contactTitle">
                  メールアドレス
                  {/* <span>※必須</span> */}
                </Label>
                <AvInput
                  type="text"
                  name="email"
                  id="examplePassword22"
                  placeholder="example@socialmap.jp"
                  className="form-control mb-2"
                  required
                  onChange={(e) =>
                    setContents({ ...contents, email: e.target.value })
                  }
                />
              </div>

              <div className="box ema__flex ema__align_items_center">
                <Label for="exampleAddress" className="contactTitle">
                  電話番号
                </Label>
                <AvInput
                  type="text"
                  name="tel"
                  id="exampleAddress"
                  placeholder="090-1234-5678"
                  className="form-control mb-2"
                  onChange={(e) => {
                    setContents({ ...contents, phoneNumber: e.target.value });
                  }}
                />
              </div>

              <div className="box ema__flex ema__align_items_center">
                <Label for="exampleAddress2" className="contactTitle">
                  お問合せ内容
                  {/* <span>※必須</span> */}
                </Label>
                <AvInput
                  className="form-control textarea"
                  type="textarea"
                  name="comment"
                  // minRows={3}
                  maxRows={6}
                  placeholder="お問合せ内容を入力してください"
                  required
                  onChange={(e) => {
                    setContents({ ...contents, comment: e.target.value });
                  }}
                />
              </div>
            </div>
            <FormGroup>
              <Button
                className="ema__btn__main contactBtn"
                type="submit"
                onClick={() => {
                  onSubmit();
                }}
              >
                送る
              </Button>
            </FormGroup>
          </div>
        </AvGroup>
      </AvForm>
    </Fragment>
  );
};

export default FormContents;
